<template>
  <t-text-input
    :mask="mask"
    v-bind="$attrs"
    :hint="format"
    :rules="validationRules"
    :model-value="modelValue"
    type="text"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import TTextInput from "@/components/core/TTextInput.vue";
import { DateTime } from "luxon";

interface Props {
  mask?: string;
  format?: string;
  rules?: ((v?: string | number) => boolean | string)[];
  modelValue?: string | null;
}

const {
  mask = "##/##/####",
  format = "dd/mm/aaaa",
  rules = [],
  modelValue = undefined,
} = defineProps<Props>();

defineOptions({
  name: "TDateInput",
  inheritAttrs: false,
});

const validationRules = computed((): ((date?: string | number) => boolean | string)[] => {
  const validateDateFormat = (date?: string | number): boolean | string => {
    if (!date) return true;

    const dateStr = date.toString();
    const regex = /^([0-9]{2})\/[0-9]{2}\/([0-9]{4})$/g;

    return regex.test(dateStr) || `A data precisa estar no formato ${format}`;
  };

  const validateDate = (date?: string | number): boolean | string => {
    if (!date) return true;

    const parsed = DateTime.fromFormat(date.toString(), "dd/MM/yyyy");

    return parsed.isValid || "Data inválida";
  };

  return [...rules, validateDateFormat, validateDate];
});
</script>
